import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"
import { LeadsSettingsHelper } from "~/helpers/leads_settings_helper"

export default class extends Controller {
  static targets = ["selectList", "newListName", "saveButton", "newListNameError", "dropdownTrigger"]

  static values = { listId: Number }

  connect() {
    this.leadsListSelectize = $(this.selectListTarget).selectize()
    this.leadsListSelectize[0].selectize.on("change", () => {
      this.changeList()
    })
  }

  disconnect() {
    // Destroy the Selectize element to avoid duplication of the field
    if (this.leadsListSelectize !== undefined) {
      this.leadsListSelectize[0].selectize.destroy()
    }
  }

  dismiss() {
    // Close the dropdown by clicking on the button
    // the toggle method is not working well here
    this.dropdownTriggerTarget.click()
  }

  listTypeSelection(event) {
    if (event.params.type === "new") {
      this.newListNameTarget.disabled = false
      this.newListNameTarget.required = true
      this.leadsListSelectize[0].selectize.disable()
      this.saveButtonTarget.dataset.action = "lead-save-manager#createList"
    } else if (event.params.type === "existing") {
      this.newListNameTarget.disabled = true
      this.newListNameTarget.required = false
      this.leadsListSelectize[0].selectize.enable()
      this.saveButtonTarget.dataset.action = "domain-search--lead-save#save"
    }
  }

  // Create a new list
  createList(e) {
    e.preventDefault()
    const _this = this
    const listName = this.newListNameTarget.value

    if (this.newListNameTarget.value.length == 0) {
      this.newListNameTarget.focus()
      return this.newListNameErrorTarget.classList.remove("d-none")
    }

    fetch(App.api.createLeadList(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: listName }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status)
        }

        return response.json()
      })
      .then((response) => {
        const leadAttribute = JSON.parse(
          this.saveButtonTarget.getAttribute("data-domain-search--lead-save-attributes-param"),
        )

        // Update list ID
        this.listIdValue = response.data.id

        // Dispatch an event to trigger save action
        setTimeout(() => {
          this.dispatch("listCreated", { detail: { attributes: leadAttribute, list_id: response.data.id } })
          _this.newListNameTarget.value = ""
          _this.newListNameErrorTarget.classList.add("d-none")
          _this.dismiss()
        }, 100)

        App.analytics.posthog_capture("lead-save-manager-listCreated")
      })
      .catch((error) => {
        if (error.message === "422") {
          App.displayFlash("danger", i18n.t("js.back.leads_manager.name_already_exists"))
        } else if (error.message === "500") {
          App.displayFlash("danger", i18n.t("js.front.api_errors.internal_server_error"))
        }
      })
  }

  // This event is triggered when a lead is saved
  displayFlash({ detail: { lead } }) {
    App.displayFlash("success", i18n.t("js.back.lead_save_manager.saved", { lead: lead.email }))
  }

  // When user change list
  changeList() {
    const id = this.selectListTarget.value
    this.listIdValue = id
  }

  // Triggered when listId value change
  listIdValueChanged(newValue, previousValue) {
    if (previousValue === 0) {
      return
    }

    LeadsSettingsHelper.updateLeadsListSettings(newValue)
  }

  // Get lead lists and update the <select> with the lists
  // triggered when a list is created (listCreated event)
  updateLeadsList(event) {
    const currentListId = event.detail.list_id

    fetch(App.api.leadsList(100))
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status)
        }

        return response.json()
      })
      .then((response) => {
        // Destroy selectize
        if (this.leadsListSelectize) {
          this.leadsListSelectize[0].selectize.destroy()
          delete this.leadsListSelectize
        }

        this.selectListTarget.innerHTML = ""
        response.data.leads_lists.forEach((list) => {
          const option = document.createElement("option")
          option.setAttribute("value", list.id)
          option.setAttribute("data", JSON.stringify(list))
          option.textContent = list.name

          if (list.id === currentListId) {
            option.setAttribute("selected", true)
          }

          this.selectListTarget.appendChild(option)
        })

        // And recreate it once the list has been refreshed
        this.leadsListSelectize = $(this.selectListTarget).selectize()
        this.leadsListSelectize[0].selectize.on("change", () => {
          this.changeList()
        })
      })
      .catch((error) => {
        if (error.message === "500") {
          App.displayFlash("danger", i18n.t("js.front.api_errors.internal_server_error"))
        }
      })
  }
}
